import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";

import { FaAngleRight } from "react-icons/fa";
import { FaArrowAltCircleUp } from "react-icons/fa";
import logo from "../images/logo.png";
import { SearchContext } from "./Contexts/Context";

import Subscribe from "./subscription/Subscribe";
import { getMenu } from "../service/service";

function Footer() {
  const { language } = useContext(SearchContext);
  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [content, setContent] = useState([]);

  const date = new Date();
  const currentYear = date.getFullYear();

  useEffect(() => {
    const getMainMenu = async () => {
      const res = await getMenu();
      setContent(res);
    };
    getMainMenu();
  }, []);

  return (
    <div className="footer">
      <div className="topFooter padding-280px">
        <div className="">
          <Link to="/meria-samartlebrivi-aqtebi">
            <img
              src={require("../images/meriaSamarlebriviaqtebi.png")}
              alt=""
            />
          </Link>
        </div>

        <div className="">
          <Link to="/sajaro-Informacia">
            <img src={require("../images/Group 272.png")} alt="" />
          </Link>
        </div>
        <div className="">
          <Link to="/peticia">
            <img src={require("../images/Group 271.png")} alt="" />
          </Link>
        </div>

        <div className="">
          <Link to="/writeMessage">
            <img src={require("../images/Group 270.png")} alt="" />
          </Link>
        </div>
      </div>
      <div className="bottomFooter ">
        {<Subscribe language={language} />}
        <div className="footer-nav padding-280px">
          {content.map((qveItem, index) => (
            <div style={{ display: "flex" }} key={index}>
              <span>{qveItem.name}</span>
              {qveItem.children &&
                qveItem.children.map((subItem, subIndex) => (
                  <span key={subIndex}>
                    <Link to={`/${subItem.slug}`}>
                      <FaAngleRight />
                      {subItem.name}
                    </Link>
                  </span>
                ))}
            </div>
          ))}
        </div>
        <div className="credits padding-280px">
          <div className="">
            <img src={logo} alt="" />
          </div>
          <div className="">
            <span>
              &copy; {language == 1 && `ყველა უფლება დაცულია ${currentYear}`}
              {language == 2 && `All rights reserved ${currentYear}`}
              {language == 3 && `все права защищены ${currentYear}`}
            </span>
          </div>
          <div className="">
            <span>
              Created by{" "}
              <a href="https://lumos.com.ge/" target="blank">
                Lumos Development
              </a>
            </span>
          </div>
        </div>
        <div className="goToTop" onClick={goToTop}>
          <FaArrowAltCircleUp />
        </div>
      </div>
    </div>
  );
}

export default Footer;
